import React, { useState, useEffect } from "react";
import SchedulingBlock from "./SchedulingBlock/index";
import ScheduleTitle from "./ScheduleTitle/index";
import conexao from "../../../../Services/index";
import { CircularProgress } from "@mui/material";
import { StateGlobal } from "../../../../Utility/Context/RegisterContext";
import ModalDetailsSchedule from "../../../../components/ModalDetailsSchedule";

export default function Schedule(props) {
  const {
    bodyFilterScheduling,
    setBodyFilterScheduling,
    dataHistoric,
    setDataHistoric,
    rowId,
  } = StateGlobal();
  const [progress, setProgress] = useState(true);
  const [finalProgress, setFinalProgress] = useState(false);
  const [endData, setEndData] = useState(0);
  const [open, setOpen] = useState(false);
  const [valueRowDatails, setValueRowDatails] = useState();

  async function getDetails() {
    try {
      const response = await conexao.post(
        "api/user/schedule/historic/detailed",
        { schedule_id: rowId }
      );
      setValueRowDatails(response.data);
    } catch (err) {}
  }

  useEffect(() => {
    getDetails();
  }, [rowId]);

  function viewModal() {
    if (open === false) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }

  function checkPage() {
    if (props.scrollTop + props.clientHeight === props.scrollHeight) {
      setBodyFilterScheduling({
        page: bodyFilterScheduling.page + 1,
        start: bodyFilterScheduling.start,
        end: bodyFilterScheduling.end,
        send: bodyFilterScheduling.send,
      });
      if (endData === 1) {
        setFinalProgress(false);
      } else {
        setFinalProgress(true);
      }
    }
  }

  async function getHistoric() {
    try {
      const response = await conexao.post("api/user/schedule/historic", {
        start: bodyFilterScheduling.start,
        end: bodyFilterScheduling.end,
        page: bodyFilterScheduling.page,
      });
      if (response.data.length !== 0) {
        setDataHistoric((oldState) => [...oldState, ...response.data]);
        setFinalProgress(false);
      }
      if (response.data.length === 0) {
        setEndData(1);
      }
    } catch (err) {}
  }

  useEffect(() => {
    if (
      bodyFilterScheduling.send !== true &&
      bodyFilterScheduling.start === null
    ) {
      getHistoric();
    }
  }, [bodyFilterScheduling.page]);

  useEffect(() => {
    checkPage();
  }, [props.scrollTop + props.clientHeight === props.scrollHeight]);

  useEffect(() => {
    if (bodyFilterScheduling.send === true) {
      setProgress(true);
      setDataHistoric([]);
      setTimeout(() => {
        setProgress(false);
      }, [2000]);
      getHistoric();
    } else if (bodyFilterScheduling.send === false) {
      setProgress(true);
      setDataHistoric([]);
      setTimeout(() => {
        setProgress(false);
      }, [2000]);
    }
  }, [bodyFilterScheduling.send]);

  return (
    <>
      {progress ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            height: "450px",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          {open === true ? (
            <ModalDetailsSchedule
              open={open}
              funcao={viewModal}
              info={valueRowDatails}
            />
          ) : (
            ""
          )}
          <ScheduleTitle />
          {dataHistoric.map((item, index) => {
            return (
              <div key={String(index)}>
                <SchedulingBlock
                  info={item}
                  open={viewModal}
                  rowId={index.id}
                />
              </div>
            );
          })}

          {finalProgress ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                height: "100px",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
}
